
import { MessagesService } from "@/services/messages-service";
import { EmailTemplateInfo } from "@/utils/email-template-info";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			templates: [] as EmailTemplateInfo[]
		};
	},
	props: {
		value: {
			type: [Object as ()=>EmailTemplateInfo, Number]
		},
		useIds: Boolean,
		fancy: Boolean,
		label: {
			type: [String, Object as ()=>TranslateResult]
		},
		hasNull: Boolean
	},
	computed: {
		selectedValue():EmailTemplateInfo | null{
			if (!this.value || this.value == 0) return null;
			if (typeof(this.value) == "number"){
				return this.templates.find(t=>t.ID == this.value) || null;
			}
			return this.templates.find(t=>t.ID == (this.value as EmailTemplateInfo).ID) || null;
		},
		items():ISelectItem<EmailTemplateInfo | null>[]{
			let values:ISelectItem<EmailTemplateInfo | null>[] = this.templates.map(t=>{
				return {
					text: t.Name,
					value: t
				};
			});

			if (this.hasNull){
				values.unshift({
					text: this.$ct("common.none").toString(),
					value: null
				});
			}

			return values;
		},
	},
	methods: {
		onInput(value:EmailTemplateInfo | null){
			if (!value){
				this.$emit("input", 0);
				return;
			}
			if (this.useIds){
				this.$emit("input", value.ID);
				return;
			}
			return this.$emit("input", value.clone());
		}
	},
	async created(){
		this.templates = await MessagesService.getSaleTemplates();
	}
});
